// client/src/data/foundingShops.js
//
// Content for the scene-facing landing page at /shops
// (components/shops/ShopsLanding.jsx). Edit this file as founding shops sign
// on — the page fills itself in from it.
//
// Rule from the scene playbook: nothing here is ever made up. No placeholder
// logos dressed as real shops, no stock photos, no invented events. The
// "Shops on On-Screen" wall stays hidden until enough real shops are listed
// (MIN_SHOPS_FOR_WALL in ShopsLanding.jsx), and until ARCHIVE_PAGES has real
// entries the archive section shows what a page carries instead.

/**
 * How many founding spots the offer has. Planning reference only — the page
 * no longer displays any spot counts.
 */
export const FOUNDING_SPOTS = 10;

/**
 * Shops that have signed on, in the order they joined. The page shows exactly
 * these, once there are at least MIN_SHOPS_FOR_WALL of them.
 * { name, neighborhood, logo?, archiveUrl? }
 *   logo        — path under /public or an absolute URL (square works best)
 *   archiveUrl  — the shop's public event-history / event page
 */
export const FOUNDING_SHOPS = [];

/**
 * Real public event pages to feature in "The archive" section (2–3 is plenty).
 * { title, shop, date, url, image? }
 */
export const ARCHIVE_PAGES = [];

/**
 * A live event page to show off from the hero ("See a live event page").
 * Leave empty until the demo raffle / event page from week 1 exists — the
 * hero link then scrolls to the archive section instead.
 */
export const FEATURED_EVENT_URL = '';

/** Where the founder can be reached directly, shown in the "Built by a small, independent team" card. */
export const FOUNDER_INSTAGRAM = '';
